<template>
  <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>A42686CC-0FE5-42E4-8F2D-18F73F16C4F8</title>
    <defs>
      <rect id="path-1" x="0" y="0" width="376" height="820" rx="8"></rect>
      <filter x="-1.9%" y="-0.6%" width="103.7%" height="101.7%" filterUnits="objectBoundingBox" id="filter-3">
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
      </filter>
      <filter id="filter-4">
        <feColorMatrix color-interpolation-filters="sRGB" in="SourceGraphic" type="matrix" values="0 0 0 0 0.207843 0 0 0 0 0.572549 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
      </filter>
      <polygon id="path-5" points="6 0 6 6 0 6 0 8 6 8 6 14 8 14 8 8 14 8 14 6 8 6 8 0"></polygon>
    </defs>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard---Hourly-Task" transform="translate(-833.000000, -263.000000)">
        <rect fill="#FFFFFF" x="0" y="0" width="1440" height="1024"></rect>
        <g id="Content" transform="translate(128.000000, 120.000000)">
          <g id="Tasks" transform="translate(404.000000, 0.000000)">
            <g id="Background">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <g>
                <use fill="black" fill-opacity="1" filter="url(#filter-3)" xlink:href="#path-1"></use>
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1"></use>
              </g>
            </g>
            <g id="Add" transform="translate(301.000000, 143.000000)">
              <g filter="url(#filter-4)" id="Variables/Icon/Add">
                <g id="Group" transform="translate(9.000000, 9.000000)">
                  <mask id="mask-6" fill="white">
                    <use xlink:href="#path-5"></use>
                  </mask>
                  <use id="Mask" fill="#000000" xlink:href="#path-5"></use>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AddPlusIcon',
};
</script>
